import React from "react";
import { lazy, Suspense } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


const InquiryOtp = ({
  firstInputRef,
  otp,
  handleOtpChange,
  otpError,
  handleBack,
}) => {
  return (
    <Suspense fallback={<div>Loading OTP form...</div>}>
      <Button onClick={handleBack} startIcon={<ArrowBackIcon />} sx={{ mb: 2 }}>
        Back
      </Button>
      <TextField
        inputRef={firstInputRef}
        autoFocus
        margin="dense"
        id="otp"
        label="Enter OTP"
        type="text"
        fullWidth
        variant="outlined"
        value={otp}
        onChange={handleOtpChange}
        placeholder="Enter the 4-digit OTP"
        required
        error={otpError}
        helperText={otpError ? "Invalid OTP" : ""}
        inputProps={{ required: true, maxLength: 4 }}
      />
    </Suspense>
  );
};

export default InquiryOtp;
